/** @format */

import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { DPV_CODE } from '@shared/data-access/enums';
import { CheckoutAnalyticsService } from '@shared/data-access/services';

@Component({
  imports: [HmfButtonComponent],
  selector: 'shared-components-suggested-address-modal',
  templateUrl: './suggested-address-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './suggested-address-modal.component.scss',
})
export class SuggestedAddressModalComponent {
  private readonly dialogRef = inject(MatDialogRef<SuggestedAddressModalComponent>);
  private readonly checkoutAnalyticsService = inject(CheckoutAnalyticsService);
  public readonly data = inject(MAT_DIALOG_DATA);

  get unverifiedAddress() {
    return this.data?.avsResponse?.unverifiedAddress;
  }

  get suggestedAddress() {
    return this.data?.avsResponse?.verifiedAddress;
  }

  get names() {
    return this.data?.names;
  }

  buttonClicked(decision: boolean) {
    this.checkoutAnalyticsService.triggerAnalyticsEvent(
      decision
        ? 'AvsV2:SuggestedAddress:UseSuggestedAddressButtonClick'
        : 'AvsV2:SuggestedAddress:EditAddressButtonClick',
      {
        dpvCode: DPV_CODE.INVALID_ADDRESS,
      },
    );
    this.dialogRef.close(decision);
  }

  close() {
    this.dialogRef.close();
  }
}
